var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("TranscriptParticipants", {
    attrs: { participants: _vm.participants, editable: "" },
    on: {
      edit: _vm.openModal,
      add: _vm.openModalAdd,
      remove: _vm.confirmRemove
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }